// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"93957e42271ab869b543","404":"d0a3006940cf2edec6c5","406":"fa3bbf5f3e0cb979e765"}[chunkId] + ".css";
};